import React from 'react';

const HowPackagesWork = () => (
  <div className="space-y-4 text-sm sm:text-base text-foreground leading-relaxed">
    <h2 className="text-base font-extrabold text-tca-blue uppercase tracking-wide underline mb-4">
      HOW OUR RETAINER PACKAGES WORK
    </h2>
    <p>
      We offer 3 (three) levels of services, each of which is comprised of 3 (three) suites of services that we call "packages".
    </p>
    <p>
      The three levels are <strong>Starter</strong>, <strong>Core</strong>, and <strong>Elite</strong>. Each level is then further broken down into <strong>Bronze</strong>, <strong>Silver</strong>, and <strong>Gold</strong>. In total, there are 9 (nine) various packages to choose from.
    </p>

    <div className="mt-4">
      <p className="font-extrabold text-tca-blue uppercase tracking-wide text-sm mb-3">Levels:</p>
      <div className="space-y-3 pl-4">
        <p className="hanging-indent">
          <span className="font-semibold">— The STARTER level</span> is ideal for <strong className="underline">Non-VAT</strong> Registered companies that are managed by 1–2 owners, have a small staff complement, and don't need reviewed or audited financial statements. Only a Compilation of the financial statements is required.
        </p>
        <p className="hanging-indent">
          <span className="font-semibold">— The CORE level</span> is ideal for <strong className="underline">VAT</strong>-Registered companies that are managed by 1–4 owners, have a small-to-large staff complement, and are legally required to prepare Reviewed financial statements.
        </p>
        <p className="hanging-indent">
          <span className="font-semibold">— The ELITE level</span> is ideal for either <strong className="underline">Non-VAT</strong> or <strong className="underline">VAT</strong>-Registered companies that are managed by 1–10 owners, have a small-to-large staff complement, and are legally required to prepare Audited financial statements.
        </p>
      </div>
    </div>

    <div className="mt-4">
      <p className="font-extrabold text-tca-blue uppercase tracking-wide text-sm mb-3">Packages:</p>
      <div className="space-y-3 pl-4">
        <p className="hanging-indent">
          <span className="font-semibold">— The BRONZE package</span> is ideal for owner-managed businesses where the owners are hands-on, do the accounting themselves (and don't need a designated accountant from us), and merely require us to "check" the books and postings.
        </p>
        <p className="hanging-indent">
          <span className="font-semibold">— The SILVER package</span> is ideal for larger businesses where the owners are juggling operations, finances, and accounting at the same time. They manage 70–80% of the accounting themselves but require a designated accountant to assist with 20–30% of the accounting, provide detailed accounting guidance, consulting, system training where necessary, and to "check" the books and postings done by the staff/owners.
        </p>
        <p className="hanging-indent">
          <span className="font-semibold">— The GOLD package</span> is ideal for large businesses where the owners are juggling clients, operations, and staff/HR at the same time. They wish to outsource either 100% or a large portion of the accounting function to us (leaving accounting to the experts). They require a designated accountant to assist with 80–100% of the accounting, provide detailed accounting guidance, consulting, system training where necessary, and to "check" the books and postings done by the staff/owners (if any).
        </p>
      </div>
    </div>
  </div>
);

export default HowPackagesWork;
